import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';

import {
  loadSubscriptionsRequested,
  loadSubscriptionsSuccess,
  loadSubscriptionsFail,
} from './subscriptionsSlice';

export function* loadSubscriptionsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/index-subscriptor?searchString=${
        action?.payload?.filters?.query ?? ''
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`
    );

    yield put(loadSubscriptionsSuccess(data));
  } catch (error: any) {
    yield put(loadSubscriptionsFail(error.message));
  }
}

export function* subscriptionsSaga(): Generator<any, void, any> {
  yield takeEvery(loadSubscriptionsRequested, loadSubscriptionsEffect);
}
